import { NewsVideosPageContainerView } from './newsVideosPageContainerView';

const props = [];

export const NewsVideosPageContainerViewDirective = (reactDirective, Metadata, MetadataDataManager) => {
    return reactDirective(
        NewsVideosPageContainerView, 
        props,
        {},
        { Metadata, MetadataDataManager });
};
NewsVideosPageContainerViewDirective.$inject = ['reactDirective', 'Metadata', 'MetadataDataManager'];

// eslint-disable-next-line no-undef
angular.module('WB.App').directive('newsVideosPageContainerView', NewsVideosPageContainerViewDirective);